import React, { useState } from "react";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import LoginHeader from "./Common/LoginHeader";
import Footer from "./Common/Footer";
import LeftTab from "./Common/LeftTab";
import { ProductName } from "./Common/ProductName";
import {
  useSupportCreateTicketMutation,
  useSupportMyTicketsQuery,
  useSupportSubjectsQuery,
} from "../redux/supportApi";
import { imageBase64, ImageValidation } from "./Validation/ImageValidation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "moment";
import SupportChatModal from "./Modals/SupportChatModal";
import { validateSpaces } from "./Validation/SpaceValidation";

const HelpFunction = () => {
  const { data: subjects } = useSupportSubjectsQuery();
  const [createTicket] = useSupportCreateTicketMutation();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatData, setChatData] = useState(null);
  const [btnDisable, setBtnDisable] = useState(false);

  const [formData, setFormData] = useState({
    issueType: "",
    issue: "",
    issueDesc: "",
    issueImage: null,
    errors: {},
  });

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10; // Set a fixed limit for items per page
  const { data: myTickets, refetch } = useSupportMyTicketsQuery({
    limit: limit,
    page: currentPage,
  });

  const totalPages = myTickets?.totalPages || 1;

  const handleChange = (e) => {
    const { name, value } = e.target;
    let errorMsg = "";

    if (name === "issueDesc") {
      errorMsg = validateSpaces(value);
    }

    if (name === "issue" && formData.issueType === "Others") {
      errorMsg = validateSpaces(value);
    }

    if (name === "issueType" && (!value || value === "Select Subject")) {
      errorMsg = "This field is required";
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [name]: errorMsg },
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    console.log(file);

    const imgError = file ? ImageValidation("Help", file, false) : "";
    console.log("imgError", imgError);

    const minSizeError =
      file && file.size < 10 * 1024 ? "Image must be at least 10KB" : "";

    const error = imgError || minSizeError || "";

    console.log("error", error);

    const url = URL.createObjectURL(file);
    console.log("url", url);

    setFormData((prev) => ({
      ...prev,
      issueImage: !error ? file : null,
      errors: { ...prev.errors, issueImage: error },
    }));
  };

  const validateForm = () => {
    const errors = {};

    const issueDescError = validateSpaces(formData.issueDesc);
    if (issueDescError) errors.issueDesc = issueDescError;

    if (!formData.issueType || formData.issueType === "Select Subject") {
      errors.issueType = "This field is required";
    }

    if (formData.issueType === "Others") {
      const issueError = validateSpaces(formData.issue);
      if (issueError) errors.issue = issueError;
    }

    if (formData.issueImage) {
      const imgError = ImageValidation("Help", formData.issueImage, false);
      if (imgError) {
        errors.issueImage = imgError;
      } else if (formData.issueImage.size < 10 * 1024) {
        errors.issueImage = "Image must be at least 10KB";
      }
    }

    setFormData((prev) => ({ ...prev, errors: { ...prev.errors, ...errors } }));
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const { issueType, issue, issueDesc, issueImage } = formData;
    const form = new FormData();
    form.append("subject", issueType === "Others" ? issue : issueType);
    form.append("body", issueDesc);
    if (issueImage && !formData?.errors?.issueImage) {
      form.append("attachment", issueImage);
    }

    try {
      setBtnDisable(true);
      setTimeout(() => setBtnDisable(false), 3000);
      const res = await createTicket(form).unwrap();
      toast.success(res.message);
      refetch();
      setFormData({
        issueType: "",
        issue: "",
        issueDesc: "",
        issueImage: null,
        errors: {},
      });
    } catch (err) {
      toast.error(
        err?.data?.message || "Something went wrong, please try again."
      );
    }
  };

  const handleOpenChat = (data) => {
    setIsChatOpen(true);
    setChatData(data);
    console.log("data", data);
  };

  const handleClose = () => {
    setIsChatOpen(false);
    setChatData(null);
  };

  const showTicketHistory = () =>
    myTickets?.data?.map((ticket) => (
      <tr key={ticket.id}>
        <td>#{ticket.id}</td>
        <td >{ticket.subject}</td>
        <td>
          {ticket?.status?.charAt(0)?.toUpperCase() + ticket.status.slice(1)}
        </td>
        <td>{Moment(ticket.created).format("lll")}</td>
        <td>{ticket.updated ? Moment(ticket.updated).format("lll") : ""}</td>
        <td>
          <button
            className="btn btn_man"
            // to={`/Chatting/${btoa(ticket.id)}/${ticket.seenStatus}`}
            onClick={() => handleOpenChat(ticket)}
          >
            {ticket.status === "pending" ? "Chat" : "View"}
          </button>
          {ticket.seenStatus === "1" && (
            <span className="position-absolute">*</span>
          )}
        </td>
      </tr>
    ));

  const meta = {
    title: `Support | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange, Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const renderPagination = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    const halfVisiblePages = Math.floor(maxVisiblePages / 2);
    let startPage = Math.max(1, currentPage - halfVisiblePages);
    let endPage = Math.min(totalPages, currentPage + halfVisiblePages);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    if (startPage > 1) {
      pageNumbers.push(
        <li key="start-ellipsis" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => setCurrentPage(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      pageNumbers.push(
        <li key="end-ellipsis" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    return (
      <nav>
        <ul className="pagination justify-content-center mt-3">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </button>
          </li>
          {pageNumbers}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <LoginHeader />
        <div className="bghwhite">
          <div className="new_inpage">
            <div className="container container2">
              <LeftTab />
              <h4 className="mb-3">Support</h4>
              <div className="row">
                {/* Form Section */}
                <div className="col-md-6">
                  <div className="white_box h_100">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label className="fw-500">Subject</label>
                        <select
                          name="issueType"
                          className="form-control"
                          onChange={handleChange}
                          value={formData.issueType}
                        >
                          <option>Select Subject</option>
                          {subjects?.data?.map((subject) => (
                            <option key={subject} value={subject}>
                              {subject}
                            </option>
                          ))}
                        </select>
                        {formData.errors.issueType && (
                          <span className="text-danger">
                            {formData.errors.issueType}
                          </span>
                        )}
                      </div>

                      {formData.issueType === "Others" && (
                        <div className="form-group">
                          <label className="fw-500">Other Subject</label>
                          <input
                            type="text"
                            name="issue"
                            className="form-control"
                            placeholder="Enter Subject"
                            value={formData.issue}
                            onChange={handleChange}
                          />
                          {formData.errors.issue && (
                            <span className="text-danger">
                              {formData.errors.issue}
                            </span>
                          )}
                        </div>
                      )}

                      <div className="form-group">
                        <label className="fw-500">Description</label>
                        <textarea
                          name="issueDesc"
                          className="form-control form_control_textarea"
                          placeholder="Enter Issue Type"
                          value={formData.issueDesc}
                          onChange={handleChange}
                        />
                        {formData.errors.issueDesc && (
                          <span className="text-danger">
                            {formData.errors.issueDesc}
                          </span>
                        )}
                      </div>

                      <div className="row">
                      <div className="form-group col-md-6">
                        <label className="fw-500">Attachment (Optional)</label>
                        <div className="uploader">
                          <input
                            type="file"
                            name="issueImage"
                            className="profile_input"
                            id="file-upload"
                            onChange={handleFileChange}
                          />
                          <label htmlFor="file-upload" id="file-drag">
                            <img
                              src={
                                formData.issueImage
                                  ? URL.createObjectURL(formData.issueImage)
                                  : "./assets/img/support.jpg"
                              }
                              className="img-fluid22 support-img"
                              alt="Attachment"
                            />
                            <div id="start">
                              <div>Upload image</div>
                            </div>
                          </label>
                        </div>
                        {formData.errors.issueImage && (
                          <span className="text-danger">
                            {formData.errors.issueImage}
                          </span>
                        )}
                      </div>
                      </div>

                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn w100px btn_man"
                          disabled={btnDisable}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Ticket History Section */}
                <div className="col-md-6">
                  <div className="white_box h_100 ticket-history">
                    <h6>Ticket History</h6>
                    <div className="table-responsive ticket-history-outer">
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>Ticket Id</th>
                            <th>Subject</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Last Updated</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>{showTicketHistory()}</tbody>
                      </table>
                      {renderPagination()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        <SupportChatModal
          show={isChatOpen}
          onClose={handleClose}
          chatData={chatData}
        />
      </div>
    </DocumentMeta>
  );
};

export default HelpFunction;
